function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.2 23.7c-.1.1-.2.1-.3.1-.7.2-1.4.2-2 0-.3-.1-.6-.3-.8-.5-.2-.2-.4-.5-.6-.8-.1-.3-.2-.6-.2-1 0-.9.5-1.7 1.4-2.3.1-.1.2-.1.3-.1 1.1-.3 2-.1 2.7.6.5.5.8 1.1.8 1.8 0 .9-.4 1.6-1.3 2.2zm5.7-15.4c-.2.5-.5 1-.8 1.5-.3.5-.7.9-1.1 1.3-.4.4-.9.9-1.4 1.3-.3.3-.6.5-.8.8-.2.2-.4.4-.5.7-.1.2-.2.5-.3.8-.1.3-.1.7-.1 1.1 0 .7-.6 1.2-1.2 1.2H7.3c-.7 0-1.2-.6-1.2-1.2v-.6c0-.5 0-.9.1-1.2l.3-.9c.1-.3.3-.5.6-.8.2-.2.5-.6.8-.9l2.5-2.6c.3-.6.6-1.3.6-2.2 0-.9-.3-1.5-.8-2.1-.6-.5-1.3-.8-2.1-.8-.9 0-1.7.3-2.3.9-.4.5-.7.9-.8 1.5-.2.5-.7.8-1.3.8L2 6.7C1.2 6.7.7 5.9.9 5.1c.1-.4.3-.9.5-1.3.4-.8 1-1.5 1.6-2.1.7-.6 1.4-1 2.3-1.3C6.2.1 7.2 0 8.2 0s1.9.1 2.7.4c.8.3 1.6.7 2.2 1.2.6.5 1.1 1.2 1.5 2 .4.8.5 1.7.5 2.7.1.8 0 1.4-.2 2z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24"
  }, props), _ref);
};

export default SvgComponent;